import React from 'react'
import { Field } from 'redux-form'
import { useDispatch } from 'react-redux'
import {
  Checkbox,
  Input,
  Select,
} from '../../../../../../../../../../itrust_common/components/form'
import {
  HORIZONTAL_BASE_OPTIONS,
  OC_REFERENCE_OPTIONS,
  VERTICAL_BASE_OPTIONS,
} from './constants'
import { getPrescriptionFieldName, handleBalanceCheck } from './helpers'
import { getPrescriptionFieldValidations } from './prescriptionValidations'

const fieldProps = {
  component: Input,
  className: 'form-control',
  wrapperClasses: 'form-group col-3',
}

const selectProps = {
  component: Select,
  className: 'custom-select',
  wrapperClasses: 'form-group col-3',
  textField: 'label',
  valueField: 'value',
}

export default function SpecteraPrescriptionEyeRow({ eyePrefix, eyeShortLabel, isSingleVision, rowDisabled = false }) {
  const dispatch = useDispatch()
  const fieldLabel = (label) => `${label} (${eyeShortLabel})`
  const inputProps = { ...fieldProps, disabled: rowDisabled }
  const dropdownProps = { ...selectProps, disabled: rowDisabled }
  const validatedInputProps = (suffix) => ({
    ...inputProps,
    validate: getPrescriptionFieldValidations(suffix),
  })

  return (
    <div className='row'>
      <div className='col-12 px-0 mt-5'>
        <div className='row mx-0'>
          <div className='col-9'></div>
          <Field
            name={getPrescriptionFieldName(eyePrefix, 'balance')}
            component={Checkbox}
            label={fieldLabel('Bal')}
            wrapperClasses="form-group col-3 d-flex align-items-end justify-content-end"
            disabled={rowDisabled}
            format={(value) => Boolean(value)}
            normalize={(value) => Boolean(value)}
            onChange={(e) => handleBalanceCheck(dispatch, eyePrefix, e.target.checked)}
          />
        </div>
      </div>
      <Field
        name={getPrescriptionFieldName(eyePrefix, 'sphere')}
        label={fieldLabel('Sphere')}
        {...validatedInputProps('sphere')}
      />
      <Field
        name={getPrescriptionFieldName(eyePrefix, 'cylinder')}
        label={fieldLabel('Cylinder')}
        {...validatedInputProps('cylinder')}
      />
      <Field
        name={getPrescriptionFieldName(eyePrefix, 'axis')}
        label={fieldLabel('Axis')}
        {...validatedInputProps('axis')}
      />
      {isSingleVision ? (
        <Field
          name={getPrescriptionFieldName(eyePrefix, 'distance_pd')}
          label={fieldLabel('Dist/Near PD')}
          {...validatedInputProps('distance_pd')}
        />
      ) : (
        <>
          <Field
            name={getPrescriptionFieldName(eyePrefix, 'distance_pd')}
            label={fieldLabel('Dist PD')}
            {...validatedInputProps('distance_pd')}
          />
          <Field
            name={getPrescriptionFieldName(eyePrefix, 'near_pd')}
            label={fieldLabel('Near PD')}
            {...validatedInputProps('near_pd')}
          />
          <Field
            name={getPrescriptionFieldName(eyePrefix, 'addition')}
            label={fieldLabel('Addition')}
            {...validatedInputProps('addition')}
          />
          <Field
            name={getPrescriptionFieldName(eyePrefix, 'segment_height')}
            label={fieldLabel('Seg Height')}
            {...validatedInputProps('segment_height')}
          />
        </>
      )}
      <Field
        name={getPrescriptionFieldName(eyePrefix, 'optical_center')}
        label={fieldLabel('OC')}
        {...validatedInputProps('optical_center')}
      />
      <Field
        name={getPrescriptionFieldName(eyePrefix, 'oc_reference')}
        label={fieldLabel('OC Reference')}
        {...dropdownProps}
        data={OC_REFERENCE_OPTIONS}
        placeholder="-- Select --"
      />
      <Field
        name={getPrescriptionFieldName(eyePrefix, 'base_curve')}
        label={fieldLabel('BC')}
        {...inputProps}
      />
      <Field
        name={getPrescriptionFieldName(eyePrefix, 'horizontal_prism')}
        label={fieldLabel('Hor Prism')}
        {...validatedInputProps('horizontal_prism')}
      />
      <Field
        name={getPrescriptionFieldName(eyePrefix, 'horizontal_base')}
        label={fieldLabel('Hor Base Dir')}
        {...dropdownProps}
        data={HORIZONTAL_BASE_OPTIONS}
        placeholder="-- Select --"
      />
      <Field
        name={getPrescriptionFieldName(eyePrefix, 'vertical_prism')}
        label={fieldLabel('Vert Prism')}
        {...validatedInputProps('vertical_prism')}
      />
      <Field
        name={getPrescriptionFieldName(eyePrefix, 'vertical_base')}
        label={fieldLabel('Vert Base Dir')}
        {...dropdownProps}
        data={VERTICAL_BASE_OPTIONS}
        placeholder="-- Select --"
      />
    </div>
  )
}
